import type { FC } from 'react'

import classNames from 'classnames'

import { LOCATION_CATEGORY_ICONS, LOCATION_CATEGORIES } from 'store/public-listing/constant'

import { List } from '../list'

import { CategoryIcon, CategoryName, CategoryItem } from './styled'

interface NearbyPlacesProps {
  categories: string[]
  onClick: (category: string) => void
  selectedCategories: string[]
  isPreview?: boolean
}

export const NearbyPlaces: FC<NearbyPlacesProps> = ({
  categories,
  onClick,
  selectedCategories,
}) => {
  const handleClick = (category: string) => () => {
    onClick(category)
  }

  return (
    <List
      dataSource={categories}
      renderItem={(category) => {
        const active = selectedCategories.includes(category)
        const lowerCaseCategory = category.toLowerCase()

        return (
          <CategoryItem
            role="button"
            key={`category-${lowerCaseCategory}`}
            id={`category-${lowerCaseCategory}`}
            as="button"
            className={classNames({ active })}
            onClick={handleClick(category)}
          >
            <CategoryIcon
              className={classNames(LOCATION_CATEGORY_ICONS[LOCATION_CATEGORIES[category]])}
            />
            <CategoryName>{category}</CategoryName>
          </CategoryItem>
        )
      }}
    />
  )
}
